export enum FacebookAdsScoreSection {
  CAMPAIGN_GOALS = 'Campaign Goals',
  ACCOUNT_ACTIVITY = 'Account Activity',
  AUDIENCE_PERFORMANCE = 'Audience Performance',
  AUDIENCE_TYPES = 'Audience Types'
}

export type FacebookAdsScoreSectionTypeKey = keyof typeof FacebookAdsScoreSection;
